import pricesReducer, { type PricesState, type Prices, type Price, type ForvaltningPriceInfo, type SpareprofilerPrice } from "./pricesReducer";

export type { PricesState, Prices, Price, ForvaltningPriceInfo, SpareprofilerPrice };

export default pricesReducer;
